import React, { useEffect, useRef } from "react";

export default function TradingViewChart({
  symbol = "XAUUSD",
  width = "100%",
  height = "320", // ⬅️ set default height smaller
}) {
  const container = useRef(null);

  useEffect(() => {
    if (!container.current) return; // ✅ stop if ref not ready
    container.current.innerHTML = ""; // clean before re-render

    // ✅ Load script dynamically
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/tv.js";
    script.async = true;

    script.onload = () => {
      // wait a tick for ref availability
      setTimeout(() => {
        if (!window.TradingView || !container.current) return;
        try {
          new window.TradingView.widget({
            autosize: true,
            symbol: symbol,
            interval: "15",
            timezone: "Etc/UTC",
            theme: "dark",
            style: "1",
            locale: "en",
            toolbar_bg: "#131722",
            hide_top_toolbar: false,
            withdateranges: true,
            enable_publishing: false,
            container_id: container.current.id,
          });
        } catch (err) {
          console.error("TradingView init failed:", err);
        }
      }, 100);
    };

    document.body.appendChild(script);
    return () => {
      script.remove();
      if (container.current) container.current.innerHTML = "";
    };
  }, [symbol]);

  return (
    <div
      id={`tv_chart_container_${symbol.replace("/", "_")}`}
      ref={container}
      className="w-full h-full bg-slate-950"
      style={{ minHeight: height }}
    />
  );
}
